import arrowDown from '@/assets/images/icons/arrow-down.svg';
import cross from '@/assets/images/icons/cross.svg';
import magnifyingGlass from '@/assets/images/icons/magnifying-glass.svg';
import { Order } from '@/types';
import { bem } from '@/utilities';
import React, { useEffect, useState } from 'react';
import { OrdersList } from './ordersList';

type Props = {
  orders: Order[];
  selectedOrder?: Order;
  setSelectedOrder: (selectedOrder: Order) => void;
};

export const SearchFieldMobile: React.FC<Props> = (props) => {
  const { orders, selectedOrder, setSelectedOrder } = props;
  const [searchedOrders, setSearchedOrders] = useState<Order[]>(orders);
  const [searchWord, setSearchWord] = useState<string>('');
  const [showOrders, setShowOrders] = useState<boolean>(false);

  useEffect(() => {
    const fliteredOrders = orders.filter((order) => order.ownedCar.carNumber.includes(searchWord));
    setSearchedOrders(fliteredOrders);
  }, [searchWord, orders]);

  const handleClickClose = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setShowOrders(false);
    setSearchWord('');
  };

  return (
    <div className={bem('schedule-selection', 'search')}>
      <div className={bem('schedule-selection', 'search-field')} onClick={() => setShowOrders(true)}>
        {selectedOrder && !showOrders ? (
          <>
            <p className={bem('schedule-selection', 'search-result')}>{selectedOrder.ownedCar.carModelName}</p>
            <img className={bem('schedule-selection', 'search-image')} src={arrowDown} />
          </>
        ) : (
          <>
            <input
              className={bem('schedule-selection', 'search-input')}
              placeholder='車両ナンバーで検索'
              onChange={(e) => setSearchWord(e.target.value)}
            />
            {showOrders ? (
              <img
                className={bem('schedule-selection', 'search-image')}
                src={cross}
                onClick={(e) => handleClickClose(e)}
              />
            ) : (
              <img className={bem('schedule-selection', 'search-image')} src={magnifyingGlass} />
            )}
          </>
        )}
      </div>
      <div className={bem('schedule-selection', 'search-list', { open: showOrders })}>
        <OrdersList
          orders={searchedOrders}
          selectedOrder={selectedOrder}
          setSelectedOrder={(selectedOrder: Order) => {
            setShowOrders(false);
            setSelectedOrder(selectedOrder);
            setSearchWord('');
          }}
        />
      </div>
    </div>
  );
};
